import React from 'react';
import QuickAccessCard, { QuickAccessGrid } from '../../components/home/quick-access-card';
import HomeSection, { HomeSectionVariant } from '../../components/home/home-section';
import { useGlobalState } from '../../global/context/global-context';

export default function SectionAccess({ variant = 'plain' }: { variant?: HomeSectionVariant }) {
  const { applicationData, parametersPortal } = useGlobalState();
  const cnpj = applicationData?.entity?.document || '';

  // Gera o nome da cidade sem espaços para o SEI
  const cityNameNoSpaces = applicationData?.entity?.address?.city
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/\s+/g, '') // Remove espaços
    || '';

  const accessItems = [
    {
      title: 'Diário Oficial',
      description: 'Consulte os diários oficiais publicados',
      icon: 'newspaper' as const,
      href: 'diario-oficial'
    },
    {
      title: 'Licitações',
      description: 'Acompanhe os processos licitatórios',
      icon: 'gavel' as const,
      href: 'licitacoes'
    },
    {
      title: 'PNCP',
      description: 'Portal Nacional de Contratações Públicas',
      icon: 'search' as const,
      href: 'https://pncp.gov.br/app/editais'
    },
    {
      title: 'Contracheque Online',
      description: 'Acesse seu contracheque online',
      icon: 'money-check-alt' as const,
      href: parametersPortal?.urlPaycheck || '#'
    },
    {
      title: 'Nota Fiscal',
      description: 'Consulte suas notas fiscais',
      icon: 'file-invoice' as const,
      href: parametersPortal?.urlNfse || '#'
    },
    parametersPortal?.urlDaily && {
      title: 'Diárias',
      description: 'Consulte diárias de servidores',
      icon: 'plane-departure' as const,
      href: parametersPortal.urlDaily
    },
    parametersPortal?.urlRevenue && {
      title: 'Receitas',
      description: 'Acompanhe as receitas públicas',
      icon: 'chart-line' as const,
      href: parametersPortal.urlRevenue
    },
    parametersPortal?.urlExpenses && {
      title: 'Despesas',
      description: 'Consulte as despesas públicas',
      icon: 'file-invoice-dollar' as const,
      href: parametersPortal.urlExpenses
    },
    {
      title: 'e-SIC',
      description: 'Sistema de Informação ao Cidadão',
      icon: 'info-circle' as const,
      href: `http://docgedsistemas.com.br/sic?codEntidade=${cnpj}&empresa=3851`
    },
    {
      title: 'e-OUV',
      description: 'Sistema de Ouvidoria',
      icon: 'comments' as const,
      href: `http://docgedsistemas.com.br/ouvidoria?codEntidade=${cnpj}&empresa=3851`
    },
    {
      title: 'e-SEI',
      description: 'Consulta de Processos',
      icon: 'file-alt' as const,
      href: `https://sip.${cityNameNoSpaces}.seibahia.ba.gov.br/login.php?sigla_orgao_sistema=${cityNameNoSpaces.toUpperCase()}&sigla_sistema=SEI`
    },
    {
      title: 'e-GED',
      description: 'Gestão de Documentos',
      icon: 'folder-open' as const,
      href: `http://docgedsistemas.com.br/minuspaper?codEntidade=${cnpj}&empresa=3851`
    },
    {
      title: 'e-SGT',
      description: 'Gestão com Transparência (LC 131)',
      icon: 'balance-scale' as const,
      href: `http://docgedsistemas.com.br/sgt?codEntidade=${cnpj}&empresa=3851`
    },
  ].filter(Boolean);

  return (
    <HomeSection id="acesso-rapido" variant={variant} title="Acesso rápido">
      <QuickAccessGrid>
        {accessItems.map((item: any, index) => (
          <QuickAccessCard
            key={index}
            title={item.title}
            description={item.description}
            icon={item.icon}
            href={item.href}
          />
        ))}
      </QuickAccessGrid>
    </HomeSection>
  );
}
